export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mc_with_tag";
})(BID_TYPE || (BID_TYPE = {}));
export const BID_MAP = {
    // 模块MV
    MODULE_MV: 'b_daodian_lowcode_cdjozahh_mv',
    // 货架Item
    GOODS_ITEM_MV: 'b_daodian_lowcode_6zhktrhj_mv',
    GOODS_ITEM_MC: 'b_daodian_lowcode_6zhktrhj_mc'
};
